export default {

    ////////Dev

    // BASE_URL: "https://wmsresourcecenter-dev.azurewebsites.net/api",

    // CLIENTID: "8cb364dc-a772-4e47-84af-f4b1a11ec70d",

    // AUTHORITY: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906",

    // REDIRECTURI: "https://wmsresourcecenter-dev.azurewebsites.net/",

    // POSTLOGOUTREDIRECTURI: "https://wmsresourcecenter-dev.azurewebsites.net/",

    // SSODOMAIN: ["exxonmobil.com", "esso.ca"],
    //Prod

     BASE_URL: "https://wmsresourcecenter.azurewebsites.net/api",

     CLIENTID: "8cb364dc-a772-4e47-84af-f4b1a11ec70d",

     AUTHORITY: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906",

     REDIRECTURI: "https://wmsresourcecenter.azurewebsites.net/",

     POSTLOGOUTREDIRECTURI: "https://wmsresourcecenter.azurewebsites.net/",

     SSODOMAIN: ["exxonmobil.com", "esso.ca"],
    //local

     //BASE_URL: "https://localhost:44312/api",

    // CLIENTID: "fc3519fe-7a63-4dc9-817f-4fefdd82130e",

    // AUTHORITY: "https://login.microsoftonline.com/08fdfb44-3c18-4aa7-9519-72bddc98ad3a",

    // REDIRECTURI: "https://localhost:44447/",

    // POSTLOGOUTREDIRECTURI: "https://localhost:44447/",

    // SSODOMAIN: ["disys.com", "dexian.com"],

};

// let config = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'production' ? {

//     BASE_URL: "https://wmsresourcecenter.azurewebsites.net/api",

//     CLIENTID: "8cb364dc-a772-4e47-84af-f4b1a11ec70d",

//     AUTHORITY: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906",

//     REDIRECTURI: "https://wmsresourcecenter.azurewebsites.net/",

//     POSTLOGOUTREDIRECTURI: "https://wmsresourcecenter.azurewebsites.net/",

//     SSODOMAIN: "exxonmobil.com",

// } : process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'staging' ? {

//     BASE_URL: "https://wmsresourcecenter-dev.azurewebsites.net/api",

//     CLIENTID: "8cb364dc-a772-4e47-84af-f4b1a11ec70d",

//     AUTHORITY: "https://login.microsoftonline.com/d1ee1acd-bc7a-4bc4-a787-938c49a83906",

//     REDIRECTURI: "https://wmsresourcecenter-dev.azurewebsites.net/",

//     POSTLOGOUTREDIRECTURI: "https://wmsresourcecenter-dev.azurewebsites.net/",

//     SSODOMAIN: "exxonmobil.com",

// } : {

//     BASE_URL: "https://localhost:44447/api",

//     CLIENTID: "fc3519fe-7a63-4dc9-817f-4fefdd82130e",

//     AUTHORITY: "https://login.microsoftonline.com/08fdfb44-3c18-4aa7-9519-72bddc98ad3a",

//     REDIRECTURI: "https://localhost:44447/",

//     POSTLOGOUTREDIRECTURI: "https://localhost:44447/",

//     SSODOMAIN: "disys.com",

// }